(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nb-look-products"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nb-look-products')){
customElements.define('nb-look-products',class extends HTMLElement{
connectedCallback(){
if(this.dataset.ready)return;this.dataset.ready='true';
this.addEventListener('click',event=>{
const button=event.target.closest('[data-look-index]');if(!button)return;
this.querySelectorAll('[data-look-index]').forEach(el=>el.setAttribute('aria-pressed',String(el===button)));
this.querySelectorAll('[data-look-panel]').forEach(el=>el.hidden=el.dataset.lookPanel!==button.dataset.lookIndex);
});
this.addEventListener('change',event=>{
const input=event.target;if(input.name!=='id')return;
const panel=input.closest('[data-look-panel]');
panel.querySelector('[data-look-price]').textContent=input.dataset.price;
panel.querySelector('[data-look-link]').href=input.dataset.url;
panel.querySelector('.nb-look__status').textContent='';
});
this.addEventListener('submit',async event=>{
const form=event.target;if(!form.matches('form'))return;event.preventDefault();
const button=form.querySelector('[type=submit]');if(button.disabled)return;
const input=form.querySelector('[name=id]:checked:not(:disabled)');if(!input)return;
const status=form.querySelector('.nb-look__status');const drawer=document.querySelector('cart-drawer');
button.disabled=true;button.textContent='ADDING…';status.textContent='';
try{
const data=new FormData(form);
if(drawer&&typeof drawer.getSectionsToRender==='function'){
data.append('sections',drawer.getSectionsToRender().map(section=>section.id).join(','));
data.append('sections_url',window.location.pathname);
if(drawer.setActiveElement)drawer.setActiveElement(button);
}
const response=await fetch(form.action+'.js',{method:'POST',headers:{'Accept':'application/json'},body:data});
const result=await response.json();
if(!response.ok||result.status)throw new Error(result.description||'Unable to add this item. Please try again.');
status.textContent='Added to cart.';
if(drawer&&result.sections&&drawer.renderContents){drawer.classList.remove('is-empty');drawer.renderContents(result);}
else{window.location.href=window.Shopify.routes.root+'cart';}
document.dispatchEvent(new CustomEvent('variant:add',{detail:{variant:{id:input.value},quantity:1,formElement:form}}));
}catch(error){status.textContent=error.message||'Unable to add this item. Please try again.';}
finally{button.disabled=false;button.textContent='ADD TO CART';}
});
}
});
}
  } catch(e) { console.error(e); }
})();

})();
